import CardDiningPreference from './CardDiningPreference';
import './CardDiningPreference.scss';

export default CardDiningPreference;
